import { useCallback, useRef } from "react"

import { useDataLayerStore } from "./dataLayerStore"
import type { UseDataLayerConfig, DetailsRecord, Events } from "./types"

type useDataLayerType = (
  event: Events,
  config?: UseDataLayerConfig
) => (details?: DetailsRecord) => void

export const useDataLayer: useDataLayerType = (
  event,
  config = { sendOnce: false }
) => {
  // Track if this hook instance has sent (for sendOnce functionality)
  const hasSent = useRef(false)
  const { sendOnce = false } = config

  // Access global queue
  const { addEvent } = useDataLayerStore()

  // Simple, stable event pushing function - always queues
  const pushEvent = useCallback(
    (details: DetailsRecord = {}) => {
      // Skip if sendOnce is enabled and already sent from this hook instance
      if (sendOnce && hasSent.current) {
        return
      }

      addEvent(event, details)

      if (sendOnce) {
        hasSent.current = true
      }
    },
    [event, sendOnce, addEvent]
  )

  return pushEvent
}
